import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export const hiddenPortfolioCategories = (
	categories: PortfolioCategoryId[],
	available: PortfolioCategoryId[],
): PortfolioCategoryId[] =>
	categories.length === 0
		? []
		: available.filter((id) => !categories.includes(id));
